import { _p, _e } from '../core.crypto';

interface AppConfiguration {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  secretKey: string;
}

// Configuración de producción (para todos los entornos excepto development)
const _cProd = {
  apiKey: 'U2FsdGVkX1+h3TNLIU892uV4Xdaowb1l6dPRdfo1506Ieh2ONJu3tsq+cuGQr275DKIlQvT7vbFZhHX9vXGSyw==',
  authDomain: 'U2FsdGVkX19vdAphSjTGxI8N3nijm1L/ZxKqulsLN9No6Lg+A5LxVJs6Hx0t+QGO',
  databaseURL: 'U2FsdGVkX1/I7EF1aISHL95o83Y/svpER6GfieL6DeGyzWcfMZy0wXUND60Lnm3v',
  projectId: 'U2FsdGVkX19DaxFSOT8l4yHY6WN3s4j790WM5cUfCR0=',
  storageBucket: 'U2FsdGVkX1+gv3gcMNl6bqK5XCh66A++LOG92XadeD0/nQbn0wxmBnqHihmQcpLf',
  messagingSenderId: 'U2FsdGVkX18KlYeZ5/0VSe8EPun8bXYs5lKXuUEVk6U=',
  appId: 'U2FsdGVkX1/tmPEabuVpuIleNyJMIag8zsKpG4Vy7uANI7k3aQc3JLKgdFEOjItPOkiu6lwrm0MYGDcQ2C0iYg==',
  secretKey: 'U2FsdGVkX1/KSD7P2/weqMB8mDWz7w4bo6XkzbLbhctgwuvOH2G3TF587+jtOBTh1TMME6lDT7yQw6UtPa+KiA=='
};

// Configuración de development
const _cDev = {
  apiKey: 'U2FsdGVkX1+Hbc7qvQ51xHjNkDIOjGw1tzM7HozPGSJlxEFObyp7Vw2FUUb+v289OZPKzRk5AvPHOvgBbRcyLg==',
  authDomain: 'U2FsdGVkX1/U3sE9nelt+hGplMJ8tRlEdhQhZtBSo9iQsQViBXLehcFKBvkhqNAFSSfVp8oAfTt5+hBQKwWmyg==',
  databaseURL: 'U2FsdGVkX1/RZGSHe9KWw9pRPjO9tt5DMxH111tr3OsJ/2kKiohTXYsPs87Y4c7rIGCJUIbKoLaQRnd2BfnEwQ==',
  projectId: 'U2FsdGVkX1+t0rePE4/UPaFTpv66Iq+mgCDiDUu73K8KpwfvKJV4vdq+IYBz+64m',
  storageBucket: 'U2FsdGVkX18N/UrjrVkTyLNJ+zH04V+S/1I5y5GoZRa7ODVNsOTgeqom2tmU+uKX',
  messagingSenderId: 'U2FsdGVkX19f6yzhTi//8+Vs1YyawzShk2TrNeNzcnY=',
  appId: 'U2FsdGVkX19JPv8i6glCeC+Pxq8Hmi5ie/jyZKMC2g5dycyMojgdBS8MFwLG7iagvER0gq2Ht1+U4O8JfaZbKw==',
  secretKey: 'U2FsdGVkX1/xvdAHq5FTjJdkaN1DhCG8Ms85hC90Nspr56X2fNRbGlsLC7cTLqEqgfRrXpiAWyAGiGPzL97EQQ=='
};

const _g = (): AppConfiguration => {
  const idx = parseInt(_e(), 10);
  // Solo development (4) usa configuración diferente, todos los demás usan producción
  const cfg = idx === 4 ? _cDev : _cProd;
  
  return _p<AppConfiguration>(cfg);
};

export const APP_CONFIG = _g();

export const SECRET_KEY = APP_CONFIG.secretKey;
